"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardBlockedSendersOption')(function discardBlockedSendersOption(state) {
    var optionState = state.optionState;
    optionState.blockedSenders = null;
}));
//# sourceMappingURL=discardBlockedSendersOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-senders-option/lib/actions/discardBlockedSendersOption.js
// module id = 5034
// module chunks = 2